import type {ReactNode} from 'react'
import {Label} from '@/components/ui/label'
import {Checkbox} from '@/components/ui/checkbox'

interface CheckboxOptionProps {
    checked: boolean
    onToggle: () => void
    children: ReactNode
    'data-testid'?: string
}

/**
 * Clickable checkbox + label row for filter popovers and multi-select lists.
 * The whole row is a `<Label>` so clicking anywhere toggles the checkbox;
 * hover highlight + pointer cursor make the hit area obvious.
 */
export function CheckboxOption({checked, onToggle, children, 'data-testid': testId}: CheckboxOptionProps) {
    return (
        <Label
            className="flex items-center gap-2 cursor-pointer hover:bg-muted p-1 rounded"
            data-testid={testId}
        >
            <Checkbox checked={checked} onCheckedChange={onToggle}/>
            {children}
        </Label>
    )
}
